<div class="container light-theme">
  @if (linkpage) {
    <div class="content">
      @if (linkpage.logo) {
        <div class="logo-container">
          <img src="{{baseUrl}}{{linkpage.logo.url}}"/>
        </div>
      }
      <div class="items-container">
        @for (item of linkpage.linkitems; track item) {
          <a [href]="item.url" target="_blank">
            <div class="item">
              <div class="item-icon">
                @if (item.img) {
                  <img src="{{baseUrl}}{{item.img.url}}"/>
                }
              </div>
              <div class="item-text">
                {{item.label}}
              </div>
            </div>
          </a>
        }
      </div>
    </div>
  }
</div>